const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const SHOP_URL = 'https://aliel-1020.myshopify.com/';
const API_USERNAME = 'a3e9dcb359a07c77bd3f4f6d7ed34141';
const API_PASSWORD = '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';

const selectors1 = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-card-wrapper',
};



if($('.product-recommendations').length){
 //console.log('product-recommendations');
  window.onload = function() {
    
    //setTimeout(()=>{
      if(document.getElementById('hdn_customerWishlistProdID') && document.getElementById('hdn_customerWishlistProdID').value !='Empty' && document.getElementById('hdn_customerWishlistProdID').value !='' && __st.cid)
      {
        let productIds= document.getElementById('hdn_customerWishlistProdID').value;
        setWishlist(productIds.split(','));
      }
    initButtons();
    initGrid(); 
  //} , 5000);
    updateWishlistCount();
  };  
}
else {
    document.addEventListener('DOMContentLoaded', () => {
     
    if(document.getElementById('hdn_customerWishlistProdID') && document.getElementById('hdn_customerWishlistProdID').value !='Empty' && document.getElementById('hdn_customerWishlistProdID').value !='' && __st.cid)
    {
      let productIds= document.getElementById('hdn_customerWishlistProdID').value;
      setWishlist(productIds.split(','));
    }  
    initButtons();
    initGrid();  
    updateWishlistCount();  
  });
}

const getMetafielId = async () =>{

  var myHeaders = new Headers();
  myHeaders.append("Authorization", 'Basic ' + btoa(API_USERNAME+':'+API_PASSWORD));

  var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  let data  = await fetch(SHOP_URL+"admin/api/2023-01/customers/"+__st.cid+"/metafields.json", requestOptions)
    .then(response => response.text())
    .then(result => {
       var resultArr = $.parseJSON(result);
        return (resultArr['metafields']) ? resultArr['metafields'][0]['id'] : '' ;   
    })
    .catch( error =>{ return '' ;} );   
   
   return data;
}

const updateContactWishlist = async (productID) => {
    if(__st.cid){
      
     const metafieldId = await getMetafielId();
     
     var myHeaders = new Headers();
	myHeaders.append("Content-Type", "application/json");
	myHeaders.append("Authorization", 'Basic ' + btoa(API_USERNAME+':'+API_PASSWORD));
    if(metafieldId)
    {
       var raw = JSON.stringify({
        "customer": {
          "id": __st.cid,
          "metafields": [
            {
              "id": metafieldId ,
              "owner_id": __st.cid,
              "namespace": "custom",
              "key": "wishlist_product_ids",
              "value": String(productID),
              "type": "single_line_text_field"
            }
          ]
        }
      }); 
    }
    else {
      var raw = JSON.stringify({
        "customer": {
          "id": __st.cid,
          "metafields": [
            {
              "owner_id": __st.cid,
              "namespace": "custom",
              "key": "wishlist_product_ids",
              "value": String(productID),
              "type": "single_line_text_field"
            }
          ]
        }
      });
    }  
	
          
	var requestOptions = {
	method: 'PUT',
	headers: myHeaders,
	body: raw,
	redirect: 'follow'
	};

	fetch(SHOP_URL+'admin/api/2022-04/customers/'+__st.cid+'.json', requestOptions)
    .then(response => response.text())
	.then(result => console.log('Done'))  
	.catch(error => console.log('error', error));
      
    }
}
    
document.addEventListener('shopify-wishlist:updated', (event) => {
  // console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  var productIds = (event.detail.wishlist.length) ? event.detail.wishlist : 'Empty';
  document.querySelector('#wishListCountHeader').innerHTML = (event.detail.wishlist.length) ? event.detail.wishlist.length : 0 ;
  updateContactWishlist(productIds);
  initGrid();
});

// document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
//   console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
// });

// document.addEventListener('shopify-wishlist:init-buttons', (event) => {
//   console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
// });

const fetchProductCardHTML = (handle) => {
  
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    let productCard = htmlDocument.documentElement.querySelector(selectors1.productCard);
    productCard = "<div class='col'>" + productCard.outerHTML + "</div>";
    return productCard;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  
  const wishlist = getWishlist();
  if(wishlist.length !== 0){
    const requests = wishlist.map(fetchProductCardHTML);
    const responses = await Promise.all(requests);
    const wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    document.querySelector('.wishlist-btn').classList.add(BUTTON_ACTIVE_CLASS);
    document.querySelector('#wishlist-count').innerHTML= wishlist.length;
    
    
  }else{
    grid.innerHTML = "<h4>Wishlist Empty</h4>";
    document.querySelector('#wishlist-count').innerHTML= 0;
    document.querySelector('#wishListCountHeader').value= 0;
    document.querySelector('.wishlist-btn').classList.toggle(BUTTON_ACTIVE_CLASS);
  }
  //document.querySelector('#wishListCountHeader').innerHTML = wishlist.length;
  updateWishlistCount();
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  
  buttons.forEach((button) => {
        //console.log($(button).hasClass("initialised"));
    if($(button).hasClass("initialised") == false)
    {
      const productHandle = button.dataset.productHandle || false;
      const productID = button.dataset.productId || false;
      button.classList.add('initialised');
      if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
      if (wishlistContains(productHandle)){
        button.classList.add(BUTTON_ACTIVE_CLASS);
        document.querySelector('.wishlist-btn').classList.add(BUTTON_ACTIVE_CLASS);
      } 
      button.addEventListener('click', () => {
        updateWishlist(productHandle,productID);
        const wishlist = getWishlist();
        button.classList.toggle(BUTTON_ACTIVE_CLASS);
        if(wishlist.length !== 0){
          document.querySelector('.wishlist-btn').classList.add(BUTTON_ACTIVE_CLASS);
        } else{
          document.querySelector('.wishlist-btn').classList.toggle(BUTTON_ACTIVE_CLASS);
        }
      });
    }   
  });
};

const initGrid = () => {
  
  const grid = document.querySelector(selectors1.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors1.button) || [];
  //console.log('Buttons-',buttons)
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle,productID) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const updateWishlistCount = (handle) => {
  var wishlist = getWishlist();
  if(wishlist.length >0){
    document.querySelector('#wishListCountHeader').innerHTML = (wishlist.length) ? wishlist.length : 0 ;
    $('#wishListCountHeader').show();
  }else{
    $('#wishListCountHeader').hide();
  }
};

const resetWishlist = () => {
  return setWishlist([]);
};

if(document.getElementById("btn-clear-wishlist"))
{
  document.getElementById("btn-clear-wishlist").addEventListener("click", resetWishlist);
}